const widgets = {
  CostItemForm: {
    component: 'FormContainer',
    children: [
      {
        component: 'Form',
        props: {
          fields: [
            {
              name: 'cost',
              label: 'costItem.entity.cost',
              type: 'endpointCombo',
              endpoint: 'cost',
              slice: 'costItem/cost/combo',
              displayField: 'id'
            },
            {
              name: 'budgetLine',
              label: 'costItem.entity.budgetLine',
              type: 'endpointCombo',
              endpoint: 'budgetLine',
              slice: 'costItem/budgetLine/combo'
            },
            {
              name: 'description',
              label: 'costItem.entity.description',
              type: 'text'
            },
            {
              name: 'unit',
              label: 'contractItem.entity.unit',
              type: 'endpointCombo',
              endpoint: 'budgetLineUnit',
              slice: 'contractItem/budgetLineUnit/combo',
              displayField: 'label',
              valueField: 'value'
            },
            {
              name: 'unitPrice',
              label: 'contractItem.entity.unitPrice',
              type: 'text'
            },
            {
              name: 'count',
              label: 'contractItem.entity.count',
              type: 'text'
            },
            {
              name: 'amount',
              label: 'costItem.entity.amount',
              type: 'text'
            },
            {
              name: 'contractItem',
              label: 'costItem.entity.contractItem',
              type: 'endpointCombo',
              endpoint: 'contractItem',
              slice: 'costItem/contractItem/combo'
            }
          ]
        }
      }
    ]
  },
  CostItemEditForm: {
    component: 'EndpointFormContainer',
    props: {
      endpoint: 'costItem',
      slice: 'costItem/costItem/edit',
      operation: 'edit',
      fancyMask: true
    },
    children: [
      {
        component: 'CostItemForm'
      }
    ]
  },
  CostItemCreateForm: {
    component: 'EndpointFormContainer',
    props: {
      endpoint: 'costItem',
      slice: 'costItem/costItem/create',
      operation: 'create',
      fancyMask: true
    },
    children: [
      {
        component: 'CostItemForm'
      }
    ]
  },
  CostItemDetailComponent: {
    component: 'EndpointDetail',
    props: {
      config: {
        groups: [
          {
            label: 'Dane podstawowe',
            columns: [
              [
                {
                  key: 'id',
                  label: 'costItem.entity.id'
                },
                {
                  key: 'cost',
                  label: 'costItem.entity.cost',
                  type: 'objectProps',
                  typeProps: {
                    props: ['id']
                  }
                },
                {
                  key: 'budgetLine',
                  label: 'costItem.entity.budgetLine',
                  type: 'objectProps',
                  typeProps: {
                    props: ['name']
                  }
                },
                {
                  key: 'description',
                  label: 'costItem.entity.description'
                },
                {
                  key: 'amount',
                  label: 'costItem.entity.amount'
                },
                {
                  key: 'contractItem',
                  label: 'costItem.entity.contractItem'
                },
                {
                  key: 'createdBy',
                  label: 'costItem.entity.createdBy',
                  type: 'objectProps',
                  typeProps: {
                    props: ['firstName', 'lastName']
                  }
                },
                {
                  key: 'updatedBy',
                  label: 'costItem.entity.updatedBy',
                  type: 'objectProps',
                  typeProps: {
                    props: ['firstName', 'lastName']
                  }
                },
                {
                  key: 'createdAt',
                  label: 'costItem.entity.createdAt',
                  type: 'datetime'
                },
                {
                  key: 'updatedAt',
                  label: 'costItem.entity.updatedAt',
                  type: 'datetime'
                }
              ]
            ]
          }
        ]
      }
    }
  },
  CostItemDetailContainer: {
    component: 'EndpointSelectedContainer',
    props: {
      endpoint: 'costItem',
      slice: 'costItem/costItem/list'
    },
    children: [
      {
        component: 'CostItemDetailComponent'
      }
    ]
  }
};

export default widgets;
